import _ from "lodash";
import { USER_STATUS_ACTIVE } from "../constants/UserConstant";
import { getUserStatus } from "./formatters";

export const getUserDataById = (webshopUsers, cmsUsers, uid) => {
  const foundWebshopUser = _.find(webshopUsers, (item) => item.userId === uid);
  if (!!foundWebshopUser) {
    let user =
      foundWebshopUser.userFirstName + " " + foundWebshopUser.userLastName + " - " + foundWebshopUser.userEmail;
    const isActive = foundWebshopUser.userStatus === USER_STATUS_ACTIVE;
    if (!isActive) user += ` (${getUserStatus(foundWebshopUser.userStatus)})`;
    return { ...foundWebshopUser, isActive, id: uid, user };
  } else {
    const foundCmsUser = _.find(cmsUsers, (item) => item.userId === uid);
    if (!!foundCmsUser) {
      let user =
        foundCmsUser.userFirstName + " " + foundCmsUser.userLastName + " - " + foundCmsUser.userEmail + " (admin)";
      const isActive = foundCmsUser.userStatus === USER_STATUS_ACTIVE;
      if (!isActive) user += ` (${getUserStatus(foundCmsUser.userStatus)})`;
      return { ...foundCmsUser, isActive, id: uid, user };
    } else return null;
  }
};
